import { Api } from "../Api";

export const carregaLayout = async (e) => {
  const { data } = await Api.get(`customizacaoCredor/listar/${e}`);
  return data;
};

export const carregaLayoutURL = async (e) => {
  const { data } = await Api.get(`customizacaoCredor/selecionaUrl/${e}`);
  return data;
};
